export default __webpack_public_path__ + "static/share-image-64c4f313daa6a09ab2c402ea5e90dc43.jpg";